import styled, { css } from 'styled-components'

import theme from '../../utils/theme'

export const StyledDropdown = styled.div.withConfig({
  shouldForwardProp: prop => !['isOpen', 'arrowPosition'].includes(prop),
})`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  padding: 10px;
  background-color: ${`var(--gameday-newDropdown-bgColor, ${theme.newDropdown.bgColor})`};
  border: 1px solid ${`var(--gameday-newDropdown-borderColor, ${theme.newDropdown.borderColor})`};
  border-radius: ${theme.newDropdown.borderRadius};
  filter: drop-shadow(2px 2px 12px ${theme.newDropdown.shadowColor});
  transition: ${theme.transitions.short};
  opacity: 0;
  transform: scale(0.98) translateY(-4px);
  transform-origin: -10px right;
  pointer-events: none;
  cursor: default;

  ${props =>
    props.isOpen &&
    css`
      opacity: 1;
      transform: scale(1) translateY(0);
      pointer-events: all;
    `}

  &:after {
    content: '';
    position: absolute;
    top: -1px;
    width: 14px;
    height: 14px;
    background-color: ${`var(--gameday-newDropdown-bgColor, ${theme.newDropdown.bgColor})`};
    border-top: 1px solid ${`var(--gameday-newDropdown-borderColor, ${theme.newDropdown.borderColor})`};

    ${props =>
      props.arrowPosition === 'left' &&
      css`
        left: 24px;
        transform: rotate(-45deg);
        transform-origin: top left;
        border-right: 1px solid ${`var(--gameday-newDropdown-borderColor, ${theme.newDropdown.borderColor})`};
      `}

    ${props =>
      props.arrowPosition === 'right' &&
      css`
        right: 24px;
        transform: rotate(45deg);
        transform-origin: top right;
        border-left: 1px solid ${`var(--gameday-newDropdown-borderColor, ${theme.newDropdown.borderColor})`};
      `}
  }
`

const StyledInnerWrap = styled.div`
  width: 100%;
  overflow-y: auto;
  padding-bottom: 4px;
`

function Dropdown({ isOpen, arrowPosition, children, dataTestId }) {
  return (
    <StyledDropdown className="Dropdown" isOpen={isOpen} arrowPosition={arrowPosition} data-testid={dataTestId}>
      <StyledInnerWrap>{children}</StyledInnerWrap>
    </StyledDropdown>
  )
}

Dropdown.defaultProps = {
  isOpen: false,
  arrowPosition: 'right',
}

export default Dropdown
